export default "__VITE_ASSET__76abda8a__"